var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.83366 6.33366H6.33366V6.83366V11.0003C6.33366 11.1825 6.18252 11.3337 6.00033 11.3337C5.81813 11.3337 5.66699 11.1825 5.66699 11.0003V6.83366V6.33366H5.16699H1.00033C0.818135 6.33366 0.666992 6.18252 0.666992 6.00033C0.666992 5.81813 0.818134 5.66699 1.00033 5.66699H5.16699H5.66699V5.16699V1.00033C5.66699 0.818134 5.81813 0.666992 6.00033 0.666992C6.18252 0.666992 6.33366 0.818135 6.33366 1.00033V5.16699V5.66699H6.83366H11.0003C11.1825 5.66699 11.3337 5.81813 11.3337 6.00033C11.3337 6.18252 11.1825 6.33366 11.0003 6.33366H6.83366Z",
    fill: "#323232",
    stroke: "#96A397"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/Add.c18ffe72dab5b2a7af1674db82888a27.svg";
export { ForwardRef as ReactComponent };